import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-material-weekly-chooser',
  templateUrl: './material-weekly-chooser.component.html',
  styleUrls: ['./material-weekly-chooser.component.css']
})
export class MaterialWeeklyChooserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
